import { type User } from 'stream-chat';

export const createStreamUser = (id: string, name: string): User => {
  const user: User = {
    id,
    image: `https://getstream.io/random_png/?name=${id}`,
    name,
  };

  return user;
};
